import React from "react";

const ProblemSection =() =>{
    return(
        <>
      <section className="container  text-center pb-2 mt-n5 pt-n5 mt-md-4 pt-md-4 mt-lg-5 pt-lg-5">
          <h2 className="h1 pt-0 pt-md-5">Have a Specific Problem <span className="fw-bold text-primary display-3">?</span></h2>
          <div className="row justify-content-center mb-md-2 mb-lg-5">
            <div className="col-md-10">
             
              <p className=" pb-2  text-center"><span className="fw-bold">Custom Solutions</span> <br/>Orbix includes a flexible AI system that can handle unique inspection challenges right out of the box. For more specific needs, our in-house development team delivers tailored features, analytics, and integrations to support your workflow.</p>
             
            </div>
          </div>
          
        </section>
       

        </>
    )

}

export default ProblemSection;